import moment from 'moment'

import 'moment/locale/pt-br'
import { getLanguage } from './locale'

moment.locale(getLanguage())

export default moment
